/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Owner_Transfer_AnyInputs */



/**
* | output |
* | --- |
* | "Handed the team over" |
*
* @param {Activity_Owner_Transfer_AnyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_owner_transfer_any = /** @type {((inputs?: Activity_Owner_Transfer_AnyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Owner_Transfer_AnyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Команда передана")
	return /** @type {LocalizedString} */ ("Handed the team over")
});